import type { ThemeCountryMap, ThemeVariantMap } from "@/theme/types";

import { apollocinemaEE } from "./EE";
import { apollocinemaLT } from "./LT";

export const apollocinemaTheme: ThemeCountryMap<ThemeVariantMap> = {
  EE: apollocinemaEE,
  LT: apollocinemaLT,
} as const;
